import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { NEW_ACTIONS } from './hubs';

/**
 * Top-bar global "+ New" creator menu. Single dropdown that scales as
 * more content/entity types are added (driven by NEW_ACTIONS in hubs.js).
 * Replaces individual "Post New Job" / "Blog Editor" sidebar entries
 * that used to clutter the sidebar before iter165. Extracted into its
 * own file during the iter175 layout refactor.
 */
export function NewButton({ permissions }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  const allowed = NEW_ACTIONS.filter((a) => !permissions || !a.permission || permissions[a.permission]);
  if (allowed.length === 0) return null;

  return (
    <div ref={ref} style={{ position: 'relative', marginRight: 4 }}>
      <button data-testid="topbar-new-button"
        onClick={() => setOpen((v) => !v)}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 6,
          padding: '6px 12px', borderRadius: 7, border: 'none', cursor: 'pointer',
          background: '#F5841F', color: '#fff', fontSize: 12.5, fontWeight: 700,
          boxShadow: '0 4px 12px rgba(245,132,31,0.25)',
        }}>
        <Plus size={13} strokeWidth={2.5} /> New
      </button>
      {open && (
        <div data-testid="topbar-new-menu"
          style={{
            position: 'absolute', top: 'calc(100% + 6px)', right: 0,
            minWidth: 220, background: '#1f2a3a', border: '1px solid rgba(255,255,255,0.08)',
            borderRadius: 10, padding: 6, boxShadow: '0 14px 40px rgba(0,0,0,0.4)',
            zIndex: 1100,
          }}>
          {allowed.map((a) => {
            const ItemIcon = a.icon;
            return (
              <button key={a.testId} data-testid={`topbar-new-${a.testId}`}
                onClick={() => { navigate(a.href); setOpen(false); }}
                style={{
                  width: '100%', display: 'flex', alignItems: 'center', gap: 10,
                  padding: '8px 10px', borderRadius: 7, border: 'none', cursor: 'pointer',
                  background: 'transparent', color: 'rgba(255,255,255,0.85)',
                  fontSize: 13, fontWeight: 500, textAlign: 'left',
                  transition: 'background 0.12s ease',
                }}
                onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.08)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}>
                <ItemIcon size={14} />
                <span>{a.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
